import React from 'react';
import LeftSidebar from './LeftSidebar';
import AICanvas from './AICanvas';
import RightSidebar from './RightSidebar';

interface CockpitMainContentProps {
  leftSidebarCollapsed: boolean;
  rightSidebarCollapsed: boolean;
  activeTab: any;
  canvasContent: any;
  onContentSelect: (content: any) => void;
  onCountChange: () => void;
  taskCount: number;
  emailCount: number;
  onUpdateTask: () => void;
  onUpdateEmail: () => void;
  onTabChange: (tab: any) => void;
}

const CockpitMainContent: React.FC<CockpitMainContentProps> = ({
  leftSidebarCollapsed,
  rightSidebarCollapsed,
  activeTab,
  canvasContent,
  onContentSelect,
  onCountChange,
  taskCount = 0,
  emailCount = 0,
  onUpdateTask,
  onUpdateEmail,
  onTabChange
}) => {
  console.log('📱 CockpitMainContent rendering');

  return (
    <div style={{
      display: 'flex',
      flex: 1,
      overflow: 'hidden'
    }}>
      {/* Left Sidebar */}
      {!leftSidebarCollapsed && (
        <LeftSidebar
          activeTab={activeTab}
          onTabChange={onTabChange}
          collapsed={false}
          onToggleCollapse={() => {}}
          onContentSelect={onContentSelect || (() => {})}
          onCountChange={onCountChange || (() => {})}
          taskCount={taskCount}
          emailCount={emailCount}
        />
      )}

      {/* Main Canvas Area */}
      <AICanvas
        content={canvasContent}
        onLeftSidebarToggle={() => {}}
        onRightSidebarToggle={() => {}}
        connectionStatus="checking"
        onTaskUpdate={onUpdateTask || (() => {})}
        onEmailUpdate={onUpdateEmail || (() => {})}
      />

      {/* Right Sidebar */}
      {!rightSidebarCollapsed && (
        <RightSidebar
          collapsed={false}
          onToggleCollapse={() => {}}
        />
      )}
    </div>
  );
};

export default CockpitMainContent;
